import apiService from '../apiService';

const baseUrl = `${window._env_.PLATFORM_API_DOMAIN}`;
const coreUrl = `${window._env_.CORE_API}`;
const subscriptionUrl = `${window._env_.SUBSCRIPTION_API_DOMAIN}`;
const businessApi = `${window._env_.BUSINESS_API_DOMAIN}`;
const callbackApi = `${window._env_.CALLBACKS_API_DOMAIN}`;
const baseUrlLegacy = `${window._env_.API_DOMAIN}/api`;

const getInviteMetadata = (hash) => {
  const url = `${baseUrl}/v1/auth/sign-up/hash/${hash}/details`;
  return apiService.get(url);
};

const getNetworkMetadata = (networkSlug = 'acca-member-benefit') => {
  const url = `${baseUrl}/v1/networks?slug=${networkSlug}`;
  return apiService.get(url);
};

const getCompanies = (query, country) => {
  const url = `${baseUrl}/v1/companies/search/${encodeURIComponent(query)}?countryCode=${country}`;
  return apiService.get(url);
};

const getCompaniesHouseLookup = (query, country) => {
  const url = `${baseUrl}/v1/companies/search/variant/${encodeURIComponent(
    query,
  )}?countryCode=${country}`;
  return apiService.get(url);
};

const getEntity = (entityId) => {
  const url = `${baseUrl}/v1/entities/${entityId}`;
  return apiService.get(url);
};

const validateEmail = (email) => {
  const url = `${baseUrl}/v1/auth/sign-up/check-email/${email}`;
  return apiService.get(url);
};

const postSalesforceLead = (data) => {
  const url = `${baseUrl}/v1/auth/sign-up/initiate`;
  return apiService.post(url, data);
};

const postSignupQuestionnaire = (data, challengeCode) => {
  const url = `${baseUrl}/v1/auth/sign-up/${challengeCode}`;
  return apiService.post(url, data);
};

const getValidateContinueUrl = (continueUrl) => {
  const url = `${businessApi}/v1/applications/validate-continue-url?continueUrl=${encodeURIComponent(
    continueUrl,
  )}`;
  return apiService.get(url);
};

const getIntroducerFromToken = (token) => {
  const url = `${coreUrl}/v1/introducers?referralCode=${token}`;
  return apiService.get(url);
};

const postUserExits = (data) => {
  const url = `${baseUrlLegacy}/v1/users/exists`;
  return apiService.post(url, data);
};

const postInviteUser = (data) => {
  const url = `${baseUrl}/v1/auth/invite/sign-up`;
  return apiService.post(url, data);
};

const postInviteSignUp = (type = 'INTRODUCER_TEAM', payload = {}) => {
  const url = `${baseUrl}/v1/auth/invite/sign-up`;
  return apiService.post(url, { ...payload, type });
};

const postInviteBundle = (payload = {}) => {
  const url = `${subscriptionUrl}/v1/bundles/assign`;
  return apiService.post(url, payload);
};

const putInviteBundle = (payload = {}) => {
  const url = `${subscriptionUrl}/v1/bundles/reassign`;
  return apiService.put(url, payload);
};

const getRemainingBundles = () => {
  const url = `${subscriptionUrl}/v1/bundles`;
  return apiService.get(url);
};

const postSignupComplete = (payload) => {
  const url = `${baseUrl}/v1/auth/social/sign-up`;
  return apiService.post(url, payload);
};

const postCancelSubscription = (entityId) => {
  const url = `${subscriptionUrl}/v1/bundles/cancel?entityId=${entityId}`;
  return apiService.post(url);
};

const deleteIntegration = ({ provider, entityId }) => {
  const url = `${callbackApi}/v1/cloud/disconnect/provider/${provider}/object/${entityId}`;
  return apiService.delete(url);
};

export {
  getIntroducerFromToken,
  getInviteMetadata,
  getCompanies,
  getCompaniesHouseLookup,
  getEntity,
  validateEmail,
  getNetworkMetadata,
  postSalesforceLead,
  postSignupQuestionnaire,
  getValidateContinueUrl,
  postUserExits,
  postInviteUser,
  postInviteSignUp,
  getRemainingBundles,
  postInviteBundle,
  postSignupComplete,
  putInviteBundle,
  postCancelSubscription,
  deleteIntegration,
};
